import ReactJsonViewCompare from "react-json-view-compare";
import ReactJson from "react-json-view";
import React from "react";

const AuditDetails = ({ auditDetails }) => {
  if (!auditDetails) {
    return null;
  }

  const { old: oldDetails, new: newDetails } = auditDetails;

  if (oldDetails && newDetails)
    return <ReactJsonViewCompare oldData={oldDetails} newData={newDetails} />;

  return <ReactJson src={auditDetails} />;
};

export default AuditDetails;
